import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

export const useUpdateGlobalUser = () => {
  const queryClient = useQueryClient();

  const update = useCallback(() => {
    queryClient.refetchQueries({ queryKey: ['get-me-once-unique'] });
  }, [queryClient]);

  return update;
};
